import { Component } from '@angular/core';
import { CascadeMenu } from '@maced/angular-components/lib/navigation-drawer/cascade-menubar/cascade-menubar.model';

@Component({
  selector: 'app-cascade-menubar',
  templateUrl: './cascade-menubar.component.html'
})
export class CascadeMenubarComponent {
  cascadeMenubarLabel = 'Table Of Content';
  backUrl = '/card';
  backQueryParams = { test: 'open' };
  closeUrl = '/button';
  closeQueryParams = { test: 'close' };
  cascadeMenuList: CascadeMenu[] = [
    { id: 'Cascade Menu', name: 'Cascade Menu', icon: 'icon-chevron-right', leadingIcon: 'icon-chevron-right', isContainSubMenu: true, url: 'https://www.google.com', target: '_self' },
    { id: 'Book 2 Level 1', name: 'Book 2 Level 1', icon: 'icon-chevron-right', leadingIcon: 'icon-chevron-right', badge: 102, url: '/card', queryParams: { test: 'test' } },
    { id: 'Book 3 Level 1', name: 'Book 3 Level 1', icon: 'icon-chevron-right', leadingIcon: 'icon-chevron-right', isContainSubMenu: true, url: '/cascade-menubar', queryParams: { test: 'test' } }
  ];
}